import { useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";

import { configure } from '../../services/request';
import { useNotification } from '../../services/notification';

import { authenticationService } from '../../services/authenticationService';

const ErrorHandler = () => {
    const notification = useRef(useNotification()).current;
    const history = useHistory();

    useEffect(() => {
        configure(config => {
            config.interceptors.response.use(
                request => {
                    return request
                },
                error => {
                    let currentUser = authenticationService.currentUserValue;
                    const { data, status } = error.response;
                    if (status >= 400 && status < 500) {
                        if ([401, 403].indexOf(status) !== -1) {
                            authenticationService.logout();
                        } else if (currentUser) {
                            notification.error(data)
                        }
                    }
                    else if (currentUser) {
                        if (typeof data === 'string' || data instanceof String) {
                            notification.error(data);
                        } else {
                            notification.error("An unexpected error has occurred.");
                        }
                    }
                    return Promise.reject(error);
                }
            )
        });
    }, [notification, history]);

    return null;
}

export default ErrorHandler;